import { RefString, RefDate, Ref } from "@tblabs/truffle";
import { v4 as uuidv4 } from 'uuid';
import { RawChatEntry } from "./RawChatEntry";
import { ChatEntryStatus } from "./ChatEntryStatus";


export class ChatEntry
{
	public Id: string = "";
	public Author = new RefString();
	public Message = new RefString();
	public Time = new RefDate();
	public Status = new Ref<ChatEntryStatus>(ChatEntryStatus.Unsent);

	constructor(raw: RawChatEntry)
	{
		this.Id = raw.Id || uuidv4();
		this.Author.value = raw.Author;
		this.Message.value = raw.Message;
		this.Time.value = raw.Time;
	}

	public get AsRaw(): RawChatEntry
	{
		return {
			Id: this.Id,
			Author: this.Author.value,
			Message: this.Message.value,
			Time: this.Time.value,
		}
	}
}
